export const LOG_LOCATION = 'applinks.extra-auth.healthcheck';
